import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useRef, useState } from 'react';

import PantryToolTipCommon from '@/components/pantry/PantryToolTipCommon';
import { getShippingFreeFee } from '@/utils/free-fee';

import styles from './index.module.scss';
import PantryIcon from '@/components/common/PantryIcon';

interface Props {
  visible: boolean;
  targetEl: React.MutableRefObject<HTMLDivElement>;
}

function PantryToolTip(props: Props) {
  const { t, lang } = useTranslation('common');
  const { visible, targetEl } = props;
  let fee = String(getShippingFreeFee());

  return (
    <PantryToolTipCommon
      tipWidth={240}
      visible={visible}
      tipStyles={{ zIndex: 500 }}
      arrowStyles={{ zIndex: 500 }}
      tipClassName={styles.tooltipBoxPantry}
      arrowClassName={styles.tooltipBoxPantryArrow}
      tip={
        <div className={styles.tooltipPantry}>
          <div className={styles.pantryTitle}>
            <PantryIcon />
          </div>
          <div className={styles.pantryContent}>
            {fee === '0' ? t('pantry_shipping_fee_free') : t('pantry_tip_content', { freeFee: fee })}
          </div>
        </div>
      }
      targetEl={targetEl}
    />
  );
}

export default PantryToolTip;
